import * as React from 'react';
import { Button } from '..';
import { useDayPicker } from '../../contexts';
/** A component rendering the navigation buttons or the drop-downs. */
export function Navigation(props) {
    var _a;
    var _b = useDayPicker(), dir = _b.dir, locale = _b.locale, classNames = _b.classNames, styles = _b.styles, _c = _b.labels, labelPrevious = _c.labelPrevious, labelNext = _c.labelNext, _d = _b.components, IconNext = _d.IconNext, IconPrevious = _d.IconPrevious;
    var onPreviousClick = props.onPreviousClick, onNextClick = props.onNextClick;
    if (dir === 'rtl') {
        _a = [onPreviousClick, onNextClick], onNextClick = _a[0], onPreviousClick = _a[1];
    }
    var previousMonth = props.previousMonth, nextMonth = props.nextMonth;
    var previousLabel = labelPrevious(previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var previousButton = (React.createElement(Button, { key: "prev", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !previousMonth, onClick: onPreviousClick },
        React.createElement(IconPrevious, { className: classNames.nav_icon, style: styles.nav_icon })));
    var nextButton = (React.createElement(Button, { key: "next", "aria-label": nextLabel, className: nextClassName, disabled: !nextMonth, onClick: onNextClick, style: styles.nav_button_next },
        React.createElement(IconNext, { className: classNames.nav_icon, style: styles.nav_icon })));
    if (!nextMonth && !previousMonth) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: classNames.nav, style: styles.nav },
        !props.hidePrevious && (dir === 'rtl' ? nextButton : previousButton),
        !props.hideNext && (dir === 'rtl' ? previousButton : nextButton)));
}
//# sourceMappingURL=Navigation.js.map